import React from "react";
import Tooltip from "@mui/material/Tooltip";
import Chip from "@mui/material/Chip";
import "./style.css";

interface QuizzerQuizSubjectInfoProps {
    percent_complete_today: number;
    daily_active_percent: number;
    daily_starting_percent: number;
    daily_questions_left: number;
    daily_questions_total: number;
    total_completion_percent: number;
    user_is_done_quizzing_for_today: boolean;
    questions_total: number;
}

export default function QuizzerQuizSubjectInfo({
    percent_complete_today,
    daily_active_percent,
    daily_starting_percent,
    daily_questions_left,
    daily_questions_total,
    total_completion_percent,
    questions_total,
    user_is_done_quizzing_for_today
}: QuizzerQuizSubjectInfoProps) {
    if (daily_active_percent == undefined) daily_active_percent = 0;
    if (total_completion_percent == undefined) total_completion_percent = 0;
    if (questions_total == undefined) questions_total = 0;
    return (
        <div className="col-xs-10 offset-xs-1 quiz-subject-tracking-info">
            <table>
                <tbody>
                    <tr>
                        <td>
                            <strong>Today</strong>
                        </td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>Percent Complete</td>
                        <td className="pull-right">
                            <b>{daily_active_percent.toFixed(0)}%</b>
                        </td>
                    </tr>
                    <tr>
                        <td>Questions Left</td>
                        <td className="pull-right">
                            <b>
                                {daily_questions_left} / {daily_questions_total}
                            </b>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            {user_is_done_quizzing_for_today ? (
                                <Chip label="Done!" color="primary" />
                            ) : (
                                ""
                            )}
                        </td>
                        <td></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>
                            <strong>Total</strong>
                        </td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>Completion Percent</td>
                        <td className="pull-right">
                            <b>{total_completion_percent.toFixed(0)}%</b>
                        </td>
                    </tr>
                    <tr>
                        <td>Questions in Deck</td>
                        <td className="pull-right">
                            <b>{questions_total.toFixed(0)}</b>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}
